/**
 * Messages génériques de l'application
 */

module.exports = {

    cancel: 'Annuler',
    back: 'Retour',
    next: 'Suivant',
    close: 'Fermer',

    delete: 'Supprimer',
    save: 'Enregistrer',
    finish: 'Terminer',
    add: 'Ajouter',
    edit: 'Éditer',
    apply: 'Appliquer',
    reset: 'Reset',
    loadMore: 'Charger plus',
    validate: 'Valider',
    confirm: 'Confirmer',
    connect: 'Connecter',
    order: 'Commander',
    generate: 'Générer',
    download: 'Télécharger',
    import: 'Importer',
    export: 'Exporter les lignes affichées',
    send: 'Envoyer',

    yes: 'Oui',
    no: 'Non',

    showMore: 'Afficher plus',
    showLess: 'Afficher moins',

    percent: '{ percent } %',

    time: {
        short: '{ hours }H{ minutes }',
        full: '{ hours }H{ minutes }\'{ seconds }\'\'',

        days: '0 jour | 1 jour | { days } jours',
        hours: '00 heure | 01 heure | { hours } heures',
        minutes: '00 minute | 01 minute | { minutes } minutes',
        seconds: '00 seconde | 01 seconde | { seconds } secondes',
    },

    size: {
        disk: '{ size } Mo'
    },

    step: 'Étape { current }/{ total }',

    icon: {
        alt: 'Icône { name }.'
    },

    password: {
        altLabel: {
            show: 'Afficher le mot de passe.',
            hide: 'Masquer le mot de passe.'
        }
    },

    list: {
        empty: 'Aucun élément n\'a été trouvé.'
    },

    contract: {
        types: {
            fixedTermContract: 'CDD',
            permanentContract: 'CDI',
            traineeship: 'Stage',
            free: 'Freelance',
            society: 'Société'
        }
    },

    lang: {
        byCode: {
            fr: 'Français',
            en: 'Anglais',
            es: 'Espagnol',
            de: 'Allemand'
        }
    },

    translation: {
        button: {
            display: {
                show: 'Afficher les traductions',
                hidden: 'Masquer les traductions'
            }
        }
    },

    week: {
        dayNames: {
            monday: 'lundi',
            tuesday: 'mardi',
            wednesday: 'mercredi',
            thursday: 'jeudi',
            friday: 'vendredi',
            saturday: 'samedi',
            sunday: 'dimanche'
        }
    },

    month: {
        current: '{ month } { year }'
    },

    frequency: {
        monthly: 'mensuelle',
        yearly: 'annuelle'
    },

    requestHolidays: {
        type: {
            paidHolidays: 'Congés payés',
            unpaidLeave: 'Congés sans solde',
            repose: 'Repos'
        },
        status: {
            waiting: 'En attente',
            accepted: 'Acceptée',
            declined: 'Refusée'
        },
    },

    editorialLine: {
        institutional: 'Institutionnel',
        humor: 'Humour',
        original: 'Original',
        inspiring: 'Inspirant',
        technicalExpert: 'Expert technique',
        pedagogue: 'Pédagogue',
        journalistic: 'Journalistique',
        promotional: 'Promotionnel',
        emotional: 'Émotionnel',
        custom: 'Ton personnalisé'
    },

    activityType: {
        unknown: 'Inconnu',
        bToC: 'BtoC',
        bToB: 'BtoB',
        bToBToC: 'BtoBtoC',
        cToC: 'CtoC'
    },

    formality: {
        familiarity: 'Tutoiement',
        formality: 'Vouvoiement'
    },

    emoticonType: {
        without: 'Sans émoji',
        institutional: 'Modéré',
        emotional: 'Émotionnel'
    },

    marketingObjectives: {
        visibility: 'Visibilité',
        traffic: 'Trafic',
        engagement: 'Engagement'
    },


    // Sélection d'un émoticône
    selectedEmoticon: {
        button: {
            category: {
                label: 'Sélectionner un émoticône'
            }
        }
    },

    // Template des chartes graphiques
    graphicalLineTemplate: {
        status: {
            draft: 'Brouillon',
            enabled: 'Activé',
            disabled: 'Désactivé'
        },
        format: {
            '1:1': 'Carré',
            '16:9': '16:9',
            '9:16': '9:16'
        }
    },

    // Plugin Pixlr
    pixlrPlugin: {
        closeButton: {
            altLabel: 'Fermer l\'éditeur.'
        }
    },

    // Plugin Konva pour l'édition d'image
    konvaPlugin: {
        addImageButton: {
            label: 'Ajouter une image'
        },
        addShapeButton: {
            label: 'Ajouter une forme'
        },
        addTextButton: {
            label: 'Ajouter une zone de texte'
        },
        removeButton: {
            altLabel: 'Supprimer cet élément.'
        },
        moveUpButton: {
            altLabel: 'Remonter cet élément.'
        },
        moveDownButton: {
            altLabel: 'Abaisser cet élément.'
        },
        expandImageButton: {
            altLabel: 'Étendre la taille de l\'image.'
        },
        changeImageButton: {
            altLabel: 'Utiliser une autre l\'image.'
        },
        changeTextContentTypeButton: {
            altLabel: 'Changer le type de texte.'
        },

        changeImageContentTypeButton: {
            altLabel: 'Changer le type d\'image.'
        },

        imageContentType: {
            type: {
                label: 'Type d\'image',
            },
            types: {
                logo: 'Logo',
                publicationImage: 'Image de publication'
            },
            isLogo: 'Logo'
        },

        fontSize: {
            label: 'Taille de police'
        },

        textMaxCharacters: {
            label: 'Nombre maximum de caractères'
        },

        textContentTypeSelect: {
            label: 'Type de texte',
            default: 'Sélectionner un type',
            options: {
                heading1: 'Titre 1',
                heading2: 'Titre 2',
                description: 'Description'
            }
        },
        opacityInput: {
            label: 'Pourcentage d\'opacité',
        },

        displayTextEditorButton: {
            altLabel: 'Éditer le texte.'
        },

        customColorButton: {
            label: 'Couleur personnalisée'
        },

        editOpacityButton: {
            altLabel: 'Modifier l\'opacité de cet élément.'
        },

        editShapeButton: {
            altLabel: 'Modifier les paramètres de cette forme.'
        },

        editShape: {
            fields: {
                type: 'Type de forme',
                backgroundColor: 'Couleur de fond',
                withBorder: 'Utiliser une bordure',
                borderSize: 'Taille de la bordure',
                borderColor: 'Couleur de la bordure',
                radius: 'Arrondis des angles',
                masked: 'Élément transparent'
            },
            color: {
                none: 'Aucune',
                custom: 'Personnalisée'
            },
            types: {
                default: 'Choisissez le type de forme',
                rectangle: 'Rectangle',
                triangle: 'Triangle',
                circle: 'Cercle'
            }
        },

        editStageBackgroundButton: {
            altLabel: 'Gérer le fond de l\'éditeur.',
        },

        addFontButton: {
            altLabel: 'Ajouter une police de caractères.'
        },

        editBackground: {
            fields: {
                type: 'Type de fond',
                color: 'Couleur de fond',
                colorIndex: 'Couleur du client',
                gradient: {
                    color: 'Couleur { position }',
                    percent: 'Démarrage au pourcentage'
                }
            },
            addGradientColorButton: {
                label: 'Ajouter une couleur'
            },
            types: {
                none: 'Aucun',
                color: 'Couleur unique',
                gradient: 'Dégradé'
            }
        },

        colorIndexes: {
            label: 'Couleur du client',
            none: 'Aucune',
            primary: 'Primaire',
            secondary: 'Secondaire',
            tertiary: 'Tertiaire'
        },

        addFontModal: {
            title: 'Ajouter une police de caractères'
        }
    },

    aiModels: {
        claude: 'Claude',
        // 'gpt-4o': 'GPT-4o',
        'gpt-5': 'GPT-5',
        'gpt-5-4-mini': 'GPT-5.4'
    },

    contactUs: {
        button: {
            altLabel: 'Envoyez-nous un message.'
        },
        modal: {
            title: 'Contactez-nous'
        },
        form: {
            error: 'Une erreur s\'est produite pendant l\'envoi de votre message.',
            success: 'Votre message a été envoyé avec succès.',
            fields: {
                email: 'Adresse email à laquelle vous contacter',
                message: 'En quoi pouvons nous vous aider'
            }
        }
    },

    pronouns: {
        firstSingular: 'Je',
        firstPlural: 'Nous',
        thirdSingular: 'On'
    },

    languageRegisters: {
        formal: 'Langage soutenu',
        familiar: 'Langage familier',
        proximity: 'Langage de proximité'
    },

    tones: {
        expert: 'Expert',
        accessible: 'Accessible',
        offbeat: 'Décalé',
        committed: 'Engagé'
    },

    writingStyle: {
        category: {
            informational: 'Informationnel',
            advice: 'Conseil',
            promotional: 'Promotionnel'
        }
    }

};
